import { AnalyticsService } from "./analytics.service";

import * as $ from 'jquery';

export class ValidationService {

	private static instance: ValidationService;

	constructor() { }

	static getInstance() {
		if (!ValidationService.instance) {
			ValidationService.instance = new ValidationService();
		}
		return ValidationService.instance;
	}

	//
	//
	// FORMS
	//
	//
	validate(fields: Element[]) {
		let analyticsService = new AnalyticsService();
		let dlFieldsError = [];
		let valid = true;
		let errors = [];
		for (let i = 0; i < fields.length; i++) {
			let field = (fields[i] as HTMLInputElement);
			let formGroup = $(field).closest('.form__group');
			if (formGroup) {
				$(field).closest('.form__group').removeClass('form__group--error');
			}
			if (!formGroup.hasClass("form__group--hidden")) {
				if (field.classList.contains('form__input--required')) {
					let type = field.type;
					if (type == 'checkbox') {
						let checked = field.checked;
						if (!checked) {
							dlFieldsError.push(field.name);
							let form_group = $(field).closest('.form__group');
							let label = form_group.find('label').text();
							form_group.addClass('form__group--error');
							errors.push(label + ' is required');
							valid = false;
						}
					} else {
						if (!field.value) {
							//Analytics - Add the fiel into the log
							dlFieldsError.push(field.name);
							let form_group = $(field).closest('.form__group');
							let label = form_group.find('label').text();
							form_group.addClass('form__group--error');
							errors.push(label + ' is required');
							valid = false;
						}
						else if (field.value.charAt(0) == " ") {
							//Analytics - Add the fiel into the log
							dlFieldsError.push(field.name);
							let form_group = $(field).closest('.form__group');
							let label = form_group.find('label').text();
							form_group.addClass('form__group--error');
							errors.push(label + ' is required');
							valid = false;
						}
					}
				}

				//Validate Text Area Field
				if (field.classList.contains('form__textarea--required')) {
					if (!field.value) {
						//Analytics - Add the fiel into the log
						dlFieldsError.push(field.name);
						let form_group = $(field).closest('.form__group');
						let label = form_group.find('label').text();
						form_group.addClass('form__group--error');
						errors.push(label + ' is required');
						valid = false;
					}
				}
				if (field.classList.contains('form__input--contact') && (field.value.length > 0)) {
					if (field.value) {
						if (!this.validateContact(field)) {
							let form_group = $(field).closest('.form__group');
							let label = form_group.find('label').text();
							form_group.addClass('form__group--error');
							errors.push(label + ' is invalid');
							valid = false;
							// Analytics - ensure that the field name is not already in the log
							if (field.name && dlFieldsError.indexOf(field.name) < 0) {
								dlFieldsError.push(field.name);
							}
						}
					}
				}
				if (field.classList.contains('form__input--contact-international')) {
					if (field.value.length > 0) {
						this.validateContactInternationalNumber(field);
					}
				}
				if (field.classList.contains('form__input--areaCode') && (field.value.length > 0)) {
					if (field.value) {
						if (!this.validateAreaCode(field)) {
							let form_group = $(field).closest('.form__group');
							let label = form_group.find('label').text();
							form_group.addClass('form__group--error');
							errors.push(label + ' is invalid');
							valid = false;
							// Analytics - ensure that the field name is not already in the log
							if (field.name && dlFieldsError.indexOf(field.name) < 0) {
								dlFieldsError.push(field.name);
							}
						}
					}
				}

				if (field.classList.contains('form__input--identification')) {
					if (field.value) {
						let form_group = $(field).closest('.form__group');
						if (!this.validateSAIDLessStrict(field) && !form_group.hasClass("form__group--hidden")) {
							let label = form_group.find('label').text();
							form_group.addClass('form__group--error');
							errors.push('South Africa ID number is invalid');
							valid = false;
							// Analytics - ensure that the field name is not already in the log
							if (field.name && dlFieldsError.indexOf(field.name) < 0) {
								dlFieldsError.push(field.name);
							}
						}
					}
				}

				if (field.classList.contains('form__input--email')) {
					if (field.value) {
						if (!this.validateEmail(field)) {
							let form_group = $(field).closest('.form__group');
							let label = form_group.find('label').text();
							form_group.addClass('form__group--error');
							errors.push(label + ' is invalid');
							valid = false;
							// Analytics - ensure that the field name is not already in the log
							if (field.name && dlFieldsError.indexOf(field.name) < 0) {
								dlFieldsError.push(field.name);
							}
						}
					}
				}

				if (field.classList.contains('form__input--currency')) {
					if (field.value) {
						if (!this.validateCurrency(field)) {
							let form_group = $(field).closest('.form__group');
							let label = form_group.find('label').text();
							form_group.addClass('form__group--error');
							errors.push(label + ' is invalid');
							valid = false;
							// Analytics - ensure that the field name is not already in the log
							if (field.name && dlFieldsError.indexOf(field.name) < 0) {
								dlFieldsError.push(field.name);
							}
						}
					}
				}

				if (field.classList.contains('form__input--account')) {
					if (field.value) {
						if (!this.validateAccount(field)) {
							let form_group = $(field).closest('.form__group');
							let label = form_group.find('label').text();
							form_group.addClass('form__group--error');
							errors.push(label + ' is invalid');
							valid = false;
							// Analytics - ensure that the field name is not already in the log
							if (field.name && dlFieldsError.indexOf(field.name) < 0) {
								dlFieldsError.push(field.name);
							}
						}
					}
				}

				if (field.classList.contains('form__input--minmaxLength')) {
					if (field.value) {
						if (!this.validateMinMaxLength(field)) {
							let form_group = $(field).closest('.form__group');
							let label = form_group.find('label').text();
							form_group.addClass('form__group--error');
							errors.push(label + ' is invalid');
							valid = false;
							// Analytics - ensure that the field name is not already in the log
							if (field.name && dlFieldsError.indexOf(field.name) < 0) {
								dlFieldsError.push(field.name);
							}
						}
					}
				}

				if (field.classList.contains('form__input--busReg')) {
					if (field.value) {
						let _check = field.value.split('/');
						let _regValid = true;
						if (_check.length > 1) {
							let _valid1 = true;
							let _valid2 = true;
							let _valid3 = true;
							if (_check.length == 3) {
								const _seg1 = new RegExp('^/d{4}$');
								const _seg2 = new RegExp('^/d{6}$');
								const _seg3 = new RegExp('^/d{2}$');
								if (_seg1.test(_check[0])) {
									_valid1 = false;
								}
								if (_seg2.test(_check[1])) {
									_valid2 = false;
								}
								if (_seg3.test(_check[2])) {
									_valid3 = false;
								}
								if (!_valid1 || !_valid2 || !_valid3) {
									valid = false;
								}
							} else {
								_regValid = false;
							}
						} else if (field.value.length >= 12) {
							const _numberCheck = new RegExp('^[0-9]+$');
							if (!_numberCheck.test(field.value)) {
								_regValid = false;
							}
						}
						if (!_regValid) {
							valid = false;
							let form_group = $(field).closest('.form__group');
							let label = form_group.find('label').text();
							form_group.addClass('form__group--error');
							errors.push(label + ' is invalid');
						}
					}
				}
				if ((field.type == 'input') || (field.type == 'textarea')) {
					var format;
					if (field.classList.contains('form__input--email')) {
						format = /[`~!#$%^&*()_+=\[\]{};:"\\|,<>\/?]/;
					}
					else if (field.type == "textarea") {
						format = /[`~#$%^*()_+=\[\]{}"\\|<>\/]/;
					}
					else {
						format = /[`~!@#$%^&*()_+=\[\]{};:"\\|,<>\/?]/;
					}
					if (format.test(field.value) && !field.classList.contains('form__input--busReg')) {
						let form_group = $(field).closest('.form__group');
						let label = form_group.find('label').text();
						form_group.addClass('form__group--error');
						errors.push(label + ' is invalid');
						valid = false;
						// Analytics - ensure that the field name is not already in the log
						if (field.name && dlFieldsError.indexOf(field.name) < 0) {
							dlFieldsError.push(field.name);
						}
					}
				}
			}
		}

		//If we have any errors on client side, trigger analytics to record all fields
		if (dlFieldsError.length) {
			analyticsService.dtmFormFieldsValidationFail(dlFieldsError.join(','));
		}

		return {
			valid: valid,
			errors: errors
		};
	}

	// 
	// 
	// FORMATTERS
	// 
	// 
	validateSAID(field: Element) {

		// global variables
		let input = (field as HTMLInputElement);
		let correct = true;
		let value = input.value;

		// check length and if its a number
		let validNumber = this.validateIsNumber(value);
		if (value.length !== 13 && !validNumber) {
			correct = false;
		}

		// valid date
		let substringYear: number = parseInt(value.substring(0, 2));
		let substringMonth: number = parseInt(value.substring(2, 4));
		let substringDay: number = parseInt(value.substring(4, 6));

		let tempDate = new Date(substringYear, substringMonth, substringDay);

		let date_day = tempDate.getDate();
		let date_month = tempDate.getMonth();
		let date_fullyear: any = tempDate.getFullYear();

		if (substringYear !== parseFloat(value.substring(0, 2))) {
			correct = false;
		} else if (date_month !== parseFloat(value.substring(2, 4))) {
			correct = false;
		} else if (date_day !== parseFloat(value.substring(4, 6))) {
			correct = false;
		}

		// Luhn formula
		let tempTotal = 0;
		let checkSum = 0;
		let multiplier = 1;
		for (let itemp = 0; itemp < 13; ++itemp) {
			tempTotal = parseInt(value.charAt(itemp)) * multiplier;
			if (tempTotal > 9) {
				tempTotal = parseInt(tempTotal.toString().charAt(0)) + parseInt(tempTotal.toString().charAt(1));
			}
			checkSum = checkSum + tempTotal;
			multiplier = (multiplier % 2 === 0) ? 1 : 2;
		}
		if ((checkSum % 10) !== 0) {
			correct = false;
		}

		// check if sa id field is valid
		if (!correct) {
			return false;
		}

		return true;
	}

	validateSAIDLessStrict(field: Element) {

		let input = (field as HTMLInputElement);
		var SAIDRegEx = /^(((\d{2}((0[13578]|1[02])(0[1-9]|[12]\d|3[01])|(0[13456789]|1[012])(0[1-9]|[12]\d|30)|02(0[1-9]|1\d|2[0-8])))|([02468][048]|[13579][26])0229))(( |-)(\d{4})( |-)(\d{3})|(\d{7}))$/;
		if (SAIDRegEx.test(input.value)) {
			return true;
		} else {
			return false
		};

	}

	validateIsNumber(n) {

		return !isNaN(parseFloat(n)) && isFinite(n);

	}

	validateCurrency(n) {
		if (n.value.toString().length > 10) {
			return false;
		} else if (this.validateIsNumber(n.value)) {
			var rgx = /^\s*(?=.*[1-9])\d*(?:\.\d{1,2})?$/;
			return n.value.match(rgx);
		}
		else {
			return false;
		}

	}

	validateContact(field: HTMLInputElement) {

		let is_zero_number_correct = true;
		let num;
		num = /^0[0-9]\d{8}$/g;
		if (num.test(field.value) === false) {
			is_zero_number_correct = false;
		} else {
			is_zero_number_correct = true;
		}
		return is_zero_number_correct;

	}

	validateContactInternationalNumber(field) {
		let valid = true;
		let dlFieldsError = [];
		let errors = [];

		if (field.value.length < 5 || field.value.length > 15) {
			let form_group = field.closest('.form__group');
			form_group.classList.add('form__group--error');
			errors.push('Please enter a valid number');
			valid = false;
			// Analytics - ensure that the field name is not already in the log
			if (field.name && dlFieldsError.indexOf(field.name) < 0) {
				dlFieldsError.push(field.name);
			}
		}
		if (isNaN(field.value)) {
			let form_group = field.closest('.form__group');
			form_group.classList.add('form__group--error');
			errors.push('Please insert only numbers in this field');
			valid = false;
			// Analytics - ensure that the field name is not already in the log
			if (field.name && dlFieldsError.indexOf(field.name) < 0) {
				dlFieldsError.push(field.name);
			}
		} else if (!this.validateContactInternational(field)) {
			let form_group = field.closest('.form__group');
			form_group.classList.add('form__group--error');
			errors.push('This contact number is invalid');
			valid = false;
			// Analytics - ensure that the field name is not already in the log
			if (field.name && dlFieldsError.indexOf(field.name) < 0) {
				dlFieldsError.push(field.name);
			}
		}
		return valid;
	}

	validateContactInternational(field: HTMLFormElement) {
		let is_zero_number_correct = true;
		let num;
		num = /^[0-9]*$/g;
		if (num.test(field.value) === false) {
			is_zero_number_correct = false;
		} else {
			is_zero_number_correct = true;
		}
		return is_zero_number_correct;
	}

	validateAreaCode(field: HTMLInputElement) {

		let areaCode = /^(?!0{4})[0-9]{4}$/g;
		if (areaCode.test(field.value)) {
			return true;
		} else {
			return false;
		}
	}

	validateEmail(field: HTMLInputElement) {

		let input = (field as HTMLInputElement);
		var EmailRegEx = /^([a-zA-Z0-9][-a-zA-Z0-9_\+\.]*[a-zA-Z0-9])@([a-zA-Z0-9][-a-zA-Z0-9\.]*[a-zA-Z0-9]\.(arpa|root|aero|biz|cat|com|coop|edu|gov|info|int|jobs|mil|mobi|museum|name|net|org|pro|tel|travel|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|ar|as|at|au|aw|ax|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gb|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kr|kw|ky|kz|la|lb|lc|li|lk|lr|ls|lt|lu|lv|ly|ma|mc|md|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|st|su|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tl|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|yu|za|zm|zw|ARPA|ROOT|AERO|BIZ|CAT|COM|COOP|EDU|GOV|INFO|INT|JOBS|MIL|MOBI|MUSEUM|NAME|NET|ORG|PRO|TEL|TRAVEL|AC|AD|AE|AF|AG|AI|AL|AM|AN|AO|AQ|AR|AS|AT|AU|AW|AX|AZ|BA|BB|BD|BE|BF|BG|BH|BI|BJ|BM|BN|BO|BR|BS|BT|BV|BW|BY|BZ|CA|CC|CD|CF|CG|CH|CI|CK|CL|CM|CN|CO|CR|CU|CV|CX|CY|CZ|DE|DJ|DK|DM|DO|DZ|EC|EE|EG|ER|ES|ET|EU|FI|FJ|FK|FM|FO|FR|GA|GB|GD|GE|GF|GG|GH|GI|GL|GM|GN|GP|GQ|GR|GS|GT|GU|GW|GY|HK|HM|HN|HR|HT|HU|ID|IE|IL|IM|IN|IO|IQ|IR|IS|IT|JE|JM|JO|JP|KE|KG|KH|KI|KM|KN|KR|KW|KY|KZ|LA|LB|LC|LI|LK|LR|LS|LT|LU|LV|LY|MA|MC|MD|MG|MH|MK|ML|MM|MN|MO|MP|MQ|MR|MS|MT|MU|MV|MW|MX|MY|MZ|NA|NC|NE|NF|NG|NI|NL|NO|NP|NR|NU|NZ|OM|PA|PE|PF|PG|PH|PK|PL|PM|PN|PR|PS|PT|PW|PY|QA|RE|RO|RU|RW|SA|SB|SC|SD|SE|SG|SH|SI|SJ|SK|SL|SM|SN|SO|SR|ST|SU|SV|SY|SZ|TC|TD|TF|TG|TH|TJ|TK|TL|TM|TN|TO|TP|TR|TT|TV|TW|TZ|UA|UG|UK|UM|US|UY|UZ|VA|VC|VE|VG|VI|VN|VU|WF|WS|YE|YT|YU|ZA|ZM|ZW)|([0-9]{1,3}\.{3}[0-9]{1,3}))$/;
		if (EmailRegEx.test(input.value)) {
			return true;
		} else {
			return false
		};

	}

	validateAccount(field: HTMLInputElement) {
		let account = /^[0-9]*$/
		if (account.test(field.value)) {
			return true;
		} else {
			return false;
		}
	}

	formatBusinessReg(event) {
		const _stringLength: number = parseFloat(event.length);
		const _newLength: number = (_stringLength - 1);
		const _check = event.substring(_newLength);
		const reg = new RegExp('^[0-9]+$');
		if (reg.test(_check)) {
			if (event.length == 4) {
				event = event += "/";
			} else if (event.length == 11) {
				event = event += "/";
			} else if (event.length > 14) {
				event = event.substring(0, 14);
			}
		}
		else {
			return event.substring(0, _newLength);
		}

		return event;
	}

	formatExpression(inputText: string) {
		let _check = inputText.split('/');
		if (_check.length > 1) {
			let _valid1 = true;
			let _valid2 = true;
			let _valid3 = true;
			if (_check.length == 3) {
				const _seg1 = new RegExp('^/d{4}$');
				const _seg2 = new RegExp('^/d{6}$');
				const _seg3 = new RegExp('^/d{2}$');
				if (_seg1.test(_check[0])) {
					_valid1 = false;
				}
				if (_seg2.test(_check[1])) {
					_valid2 = false;
				}
				if (_seg3.test(_check[2])) {
					_valid3 = false;
				}
				if (_valid1 && _valid2 && _valid3) {
					return inputText;
				} else {
					return '';
				}
			} else {
				return '';
			}
		} else if (inputText.length >= 12) {
			let _firstcharacters = inputText.substring(0, 4);
			let _secondCharacters = inputText.substring(5, 10);
			let _thirdCharacters = inputText.substring(11, 13);
			return _firstcharacters + '/' + _secondCharacters + '/' + _thirdCharacters;
		}
		return '';
	}
	
	//
	//
	// CALCULATOR
	//
	//
	validateCalculator(event: any, button: any) {

		// varaibles
		event.preventDefault();
		let field = event.target;
		let formValid = true;
		let fieldValue = field.value;
		let fieldAddon = field;
		let required: any = field.getAttribute('data-validation-required');
		let title: any = field.getAttribute('data-validation-title');
		let minimum: any = parseFloat(field.getAttribute('min'));
		let maximum: any = parseFloat(field.getAttribute('max'));
		let greaterThan: any = field.getAttribute('data-validation-greater-than');
		let lessThan: any = field.getAttribute('data-validation-less-than');

		// removeErrors
		$(field).closest('.calculator-form__group').removeClass('calculator-form__error');
		$(field).closest('.calculator-form__group').find('div.calculator-form__error-label').remove();

		// required
		if (required == "true") {
			if (fieldValue.length == 0) {
				formValid = false;
				if (minimum) {
					if (maximum) {
						if (title) {
							this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
						} else {
							this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
						}
					} else {
						this.validateCalculatorError(event, 'Enter an amount');
					}
				} else {
					this.validateCalculatorError(event, 'Enter an amount');
				}
			}
		}

		// min
		if (minimum > parseFloat(fieldValue)) {
			formValid = false;
			if (title && maximum) {
				this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
			} else if (!title && maximum) {
				this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
			} else if (!title && !maximum) {
				this.validateCalculatorError(event, 'Enter an amount');
			}
		}

		// max
		if (maximum > 0) {
			if (maximum < parseFloat(fieldValue)) {
				formValid = false;
				if (title) {
					this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum) + ' ' + title);
				} else {
					this.validateCalculatorError(event, 'Enter an amount between ' + this.formatNumbers(minimum) + ' and ' + this.formatNumbers(maximum));
				}
			}
		} else {
			if (maximum < parseFloat(fieldValue)) {
				formValid = false;
				if (title) {
					this.validateCalculatorError(event, 'The maximum you can insert is 0 ' + title);
				} else {
					this.validateCalculatorError(event, 'The maximum you can insert is 0');
				}
			}
		}

		// greater than
		if (greaterThan) {
			let fieldsGreaterThan = $(field).closest('form').find('input[name=' + greaterThan + ']');
			if (parseFloat(fieldValue) <= $(fieldsGreaterThan).val()) {
				formValid = false;
				this.validateCalculatorError(event, 'Enter an amount greater than the expenses field');
			}
		}

		// less than
		if (lessThan) {
			let fieldsLessThan: any = $(field).closest('form').find('input[name=' + lessThan + ']');
			if (fieldsLessThan.length > 1) {
				let amount: number = 0;
				$(fieldsLessThan).each(function (index) {
					let valueElement: any = $(this).val();
					if (!valueElement) {
						amount = amount + 0;
					} else {
						amount = amount + parseFloat(valueElement);
					}
				});
				if (parseFloat(fieldValue) >= amount) {
					formValid = false;
					this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
				}
			} else {
				if (parseFloat(fieldValue) >= $(fieldsLessThan).val()) {
					formValid = false;
					this.validateCalculatorError(event, 'Enter an amount (expenses may not exceed total income)');
				}
			}
		}
		return formValid;

	}

	validateCalculatorError(event: any, message = '') {
		event.preventDefault();
		let field: any = event.target;
		let closestGroup = field.closest('.calculator-form__group');
		$(closestGroup).addClass('calculator-form__error').append('<div class="calculator-form__error-label">' + message + '</div>');
	}

	formatNumbers(nStr: any) {
		nStr += '';
		let x = nStr.split('.');
		let x1 = x[0];
		let x2 = x.length > 1 ? '.' + x[1] : '';
		var rgx = /(\d+)(\d{3})/;
		while (rgx.test(x1)) {
			x1 = x1.replace(rgx, '$1' + ' ' + '$2');
		}
		return x1 + x2;

	}

	validateMinMaxLength(field: HTMLInputElement) {
		let elementMin, elementMax;
		if (field.getAttribute('minlength')) {
			elementMin = field.getAttribute('minlength');
		}
		if (field.getAttribute('maxlength')) {
			elementMax = field.getAttribute('maxlength');
		}
		if (elementMin) {
			if (field.value.length < elementMin) {
				return false;
			}
		}
		if (elementMax) {
			if (field.value.length > elementMax) {
				return false;
			}
		}
		return true;
	}

	//Custom Validation for reCaptcha
	validateReCaptcha(valid, reCaptchaFormField) {
		let dlFieldsError = [];
		let errors = [];
		let analyticsService = new AnalyticsService();

		if (reCaptchaFormField) {
			let formGroup = reCaptchaFormField.closest('.form__group');
			if (formGroup) {
				reCaptchaFormField.closest('.form__group').classList.remove('form__group--error');
				const errorMessage = reCaptchaFormField.querySelector(".form__group--error_message");
				if (errorMessage) {
					errorMessage.remove();
				}
			}
	
			if (valid == false) {
				let form_group = reCaptchaFormField.closest('.form__group');
				form_group.classList.add('form__group--error');
				errors.push('This checkbox is required to continue');
				valid = false;
				// Analytics - ensure that the field name is not already in the log
				if (reCaptchaFormField.name && dlFieldsError.indexOf(reCaptchaFormField.name) < 0) {
					dlFieldsError.push(reCaptchaFormField.name);
				}
			}
	
			//If we have any errors on client side, trigger analytics to record all fields
			if (dlFieldsError.length) {
				analyticsService.dtmFormFieldsValidationFail(dlFieldsError.join(','));
			}
		}
	}
}



// WEBPACK FOOTER //
// ./services/validation.service.ts